import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isChirpEnabled } from '../../../utils/isChirpEnabled';
import { trackInteraction } from '../../../tracking/tracker';
import { CLICK_DOWNLOAD } from '../../../tracking/actions';
import { ButtonWithBranding } from '../../ButtonWithBranding';
import { useSharedLinkDownload } from '../../../hooks/useSharedLinkDownload';
import { jsx as _jsx } from "react/jsx-runtime";
const PublicViewToolbarDownloadButton = ({
  presentation,
  sharedLink,
  brandingColor,
  fetchDownloadLink
}) => {
  const isUngatedToChirp = isChirpEnabled();
  const {
    downloadSharedLink
  } = useSharedLinkDownload();
  const handleDownloadClick = () => {
    const id = isUngatedToChirp ? sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.id : presentation === null || presentation === void 0 ? void 0 : presentation.id;
    const accessId = isUngatedToChirp ? sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.accessId : presentation === null || presentation === void 0 ? void 0 : presentation.accessId;
    if (!id) return;
    trackInteraction(CLICK_DOWNLOAD);
    if (isUngatedToChirp) {
      downloadSharedLink(id, accessId);
    } else {
      fetchDownloadLink(id, accessId || undefined).then(downloadUrl => {
        window.location = downloadUrl;
      }).catch(err => {
        console.error('REST download error:', err);
      });
    }
  };
  return /*#__PURE__*/_jsx(ButtonWithBranding, {
    marginInlineStart: "300",
    marginInlineEnd: "800",
    brandingColor: brandingColor,
    onClick: handleDownloadClick,
    "aria-label": I18n.text('a11y.downloadButton'),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "view.toolbar.download"
    })
  });
};
export default PublicViewToolbarDownloadButton;